(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["erp-home-hero"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=(root=document)=>{root.querySelectorAll('[data-home-tabs]').forEach(list=>{if(list.dataset.homeReady)return;list.dataset.homeReady='true';const tabs=[...list.querySelectorAll('[role="tab"]')];const select=tab=>{tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;const panel=document.getElementById(item.getAttribute('aria-controls'));if(panel)panel.hidden=!selected;});};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(tab));tab.addEventListener('keydown',event=>{const vertical=list.getAttribute('aria-orientation')==='vertical';let next=index;if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else if(event.key==='ArrowRight'||vertical&&event.key==='ArrowDown')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft'||vertical&&event.key==='ArrowUp')next=(index-1+tabs.length)%tabs.length;else return;event.preventDefault();select(tabs[next]);tabs[next].focus();});});});const modeLabels=document.querySelector('[data-home-mode-labels]');if(modeLabels&&!modeLabels.dataset.ready){modeLabels.dataset.ready='true';const sync=()=>document.querySelectorAll('[data-theme-toggle]').forEach(b=>b.setAttribute('aria-label',document.documentElement.classList.contains('dark')?modeLabels.dataset.light:modeLabels.dataset.dark));sync();new MutationObserver(sync).observe(document.documentElement,{attributes:true,attributeFilter:['class','data-theme']});}const dialog=document.getElementById('home-demo');if(dialog&&!dialog.dataset.homeReady){dialog.dataset.homeReady='true';let opener;document.querySelectorAll('[data-home-demo]').forEach(button=>button.addEventListener('click',()=>{opener=button;dialog.showModal();}));dialog.querySelector('[data-home-demo-close]').addEventListener('click',()=>dialog.close());dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)dialog.close();});dialog.addEventListener('close',()=>opener?.focus());}root.querySelectorAll('.eh [data-ef-whatsapp]').forEach(button=>{if(button.dataset.homeReady)return;button.dataset.homeReady='true';button.addEventListener('click',()=>{const whatsapp=document.getElementById('erp-footer-whatsapp');if(whatsapp)whatsapp.showModal();});});};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();document.addEventListener('shopify:section:load',()=>init());})();

(()=>{
  function init(){
    document.querySelectorAll('.eh-landscape').forEach(landscape=>{
      if(landscape.dataset.explorerReady)return;
      landscape.dataset.explorerReady='true';
      const overview=landscape.querySelector('[data-landscape-overview]');
      const panels=[...landscape.querySelectorAll('[data-landscape-panel]')];
      const openers=[...landscape.querySelectorAll('[data-landscape-open]')];
      const flow=landscape.querySelector('.eh-landscape-flow');
      const motionButton=landscape.querySelector('[data-landscape-motion]');
      if(flow&&motionButton){
        const motionPreference=window.matchMedia('(prefers-reduced-motion: reduce)');
        let motionPaused=motionPreference.matches;
        const setMotion=paused=>{
          motionPaused=paused;
          landscape.classList.toggle('eh-motion-paused',paused);
          const label=paused?motionButton.dataset.labelPlay:motionButton.dataset.labelPause;
          motionButton.setAttribute('aria-label',label);
          motionButton.title=label;
          if(paused)flow.pauseAnimations?.();else flow.unpauseAnimations?.();
        };
        motionButton.addEventListener('click',()=>setMotion(!motionPaused));
        const applyPreference=()=>{motionButton.hidden=motionPreference.matches;setMotion(motionPreference.matches);};
        motionPreference.addEventListener?.('change',applyPreference);
        applyPreference();
      }
      let opener;
      const close=()=>{
        panels.forEach(panel=>panel.hidden=true);
        overview.hidden=false;
        openers.forEach(button=>button.setAttribute('aria-expanded','false'));
        opener?.focus({preventScroll:true});
      };
      openers.forEach(button=>button.addEventListener('click',()=>{
        opener=button;
        const key=button.dataset.landscapeOpen;
        overview.hidden=true;
        panels.forEach(panel=>panel.hidden=panel.dataset.landscapePanel!==key);
        openers.forEach(item=>item.setAttribute('aria-expanded',String(item.dataset.landscapeOpen===key)));
        const panel=panels.find(item=>item.dataset.landscapePanel===key);
        panel?.querySelector('h3')?.focus({preventScroll:true});
      }));
      landscape.querySelectorAll('[data-landscape-back]').forEach(button=>button.addEventListener('click',close));
      panels.forEach(panel=>{
        panel.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();close();}});
        const input=panel.querySelector('[data-explorer-search]');
        const items=[...panel.querySelectorAll('[data-explorer-item]')];
        input.addEventListener('input',()=>{
          const query=input.value.trim().toLocaleLowerCase();
          let visible=0;
          items.forEach(item=>{item.hidden=!item.textContent.toLocaleLowerCase().includes(query);if(!item.hidden)visible++;});
          panel.querySelectorAll('[data-explorer-group]').forEach(group=>group.hidden=![...group.querySelectorAll('[data-explorer-item]')].some(item=>!item.hidden));
          panel.querySelector('[data-explorer-count]').textContent=String(visible);
          panel.querySelector('[data-explorer-empty]').hidden=visible!==0;
          panel.querySelector('.eh-explorer-results').scrollTop=0;
        });
      });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

(()=>{
  function init(){
    document.querySelectorAll('[data-world-search]').forEach(input=>{
      if(input.dataset.ready)return;input.dataset.ready='true';
      const panel=input.closest('[role="tabpanel"]'),items=[...panel.querySelectorAll('[data-world-country]')];
      const aliases={GB:'uk britain great britain england scotland wales northern ireland',US:'usa america united states of america',AE:'uae emirates',KR:'south korea',CZ:'czech republic'};
      const update=()=>{const q=input.value.trim().toLocaleLowerCase();let count=0;items.forEach(item=>{item.hidden=!(item.textContent+' '+item.dataset.countryCode+' '+(aliases[item.dataset.countryCode]||'')).toLocaleLowerCase().includes(q);if(!item.hidden)count++;});panel.querySelector('[data-world-count]').textContent=String(count);panel.querySelector('[data-world-empty]').hidden=count>0;panel.querySelector('[data-world-grid]').scrollTop=0;};
      input.addEventListener('input',update);update();
    });
    document.querySelectorAll('[data-ai-copy]').forEach(button=>{
      if(button.dataset.ready)return;button.dataset.ready='true';
      button.addEventListener('click',async()=>{const area=document.getElementById(button.dataset.aiCopy),status=button.nextElementSibling;try{await navigator.clipboard.writeText(area.value);status.textContent=button.dataset.copied;}catch{if(area.closest("details"))area.closest("details").open=true;area.focus();area.select();status.textContent=button.dataset.fallback;}});
    });
    const targets=[...document.querySelectorAll('.eh-ai-studio,.eh-directory-v4,.eh-compare-v4,.eh-next-links')].filter(e=>!e.dataset.motionReady);
    if('IntersectionObserver' in window){const observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){entry.target.classList.add('is-in-view');observer.unobserve(entry.target);}});},{threshold:.15});targets.forEach(e=>{e.dataset.motionReady='true';observer.observe(e);});}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

(()=>{
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const reviewControllers=new Map();
  const reviewRemovals=new MutationObserver(records=>{
    if(records.some(record=>record.removedNodes.length))reviewControllers.forEach((cleanup,home)=>{if(!home.isConnected)cleanup();});
  });
  function init(){
    document.querySelectorAll('[data-offer-motion]').forEach(root=>{
      if(root.dataset.motionBound)return;root.dataset.motionBound='true';
      const control=root.querySelector('[data-offer-toggle]');
      const toggle=()=>{const paused=root.dataset.paused!=='true';root.dataset.paused=String(paused);control.setAttribute('aria-pressed',String(paused));control.setAttribute('aria-label',paused?control.dataset.play:control.dataset.pause);};
      root.addEventListener('click',event=>{if(!event.target.closest('a'))toggle();});
      control.addEventListener('keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();toggle();}});
    });
    document.querySelectorAll('[data-home-reviews]').forEach(home=>{
      const viewport=home.querySelector('.sap-home-reviews__rail-viewport'),button=home.querySelector('[data-reviews-auto-toggle]');
      if(!viewport||!button||viewport.dataset.autoScroll)return;viewport.dataset.autoScroll='true';
      let paused=motion.matches,hover=false,focus=false,visible=false,direction=1,position=viewport.scrollLeft,previous=0,manualUntil=0,frame=null,resumeTimer=null,disposed=false;
      const listeners=[];
      const on=(target,type,handler,options)=>{target.addEventListener(type,handler,options);listeners.push(()=>target.removeEventListener(type,handler,options));};
      const setLabel=()=>{button.textContent=paused?button.dataset.play:button.dataset.pause;button.setAttribute('aria-pressed',String(paused));};
      const stop=()=>{
        if(frame!==null)cancelAnimationFrame(frame);frame=null;
        if(resumeTimer!==null)clearTimeout(resumeTimer);resumeTimer=null;
        previous=0;position=viewport.scrollLeft;
      };
      const cleanup=()=>{
        if(disposed)return;disposed=true;stop();observer.disconnect();
        listeners.forEach(remove=>remove());delete viewport.dataset.autoScroll;
        reviewControllers.delete(home);
        if(!reviewControllers.size)reviewRemovals.disconnect();
      };
      const ready=()=>!paused&&!hover&&!focus&&visible&&!document.hidden;
      const sync=()=>{
        if(disposed)return;
        if(!home.isConnected){cleanup();return;}
        stop();
        if(!ready())return;
        const delay=manualUntil-performance.now();
        if(delay>0){resumeTimer=setTimeout(()=>{resumeTimer=null;sync();},delay);return;}
        previous=performance.now();frame=requestAnimationFrame(tick);
      };
      function tick(now){
        frame=null;
        if(!home.isConnected){cleanup();return;}
        if(!ready()||now<manualUntil){sync();return;}
        const dt=Math.min(now-previous,50);previous=now;
        const max=viewport.scrollWidth-viewport.clientWidth;
        position+=direction*dt*.024;
        if(position>=max){position=max;direction=-1;}else if(position<=0){position=0;direction=1;}
        viewport.scrollLeft=position;
        frame=requestAnimationFrame(tick);
      }
      on(button,'click',()=>{paused=!paused;setLabel();sync();});setLabel();
      on(viewport,'mouseenter',()=>{hover=true;sync();});on(viewport,'mouseleave',()=>{hover=false;sync();});
      on(home,'focusin',e=>{if(e.target!==button){focus=true;sync();}});
      on(home,'focusout',e=>{if(!home.contains(e.relatedTarget)||e.relatedTarget===button){focus=false;sync();}});
      const manual=()=>{manualUntil=performance.now()+5500;sync();};
      ['pointerdown','wheel','keydown','touchstart'].forEach(type=>on(viewport,type,manual,{passive:true}));
      home.querySelectorAll('[data-home-reviews-control]').forEach(b=>on(b,'click',manual));
      on(motion,'change',()=>{paused=motion.matches;setLabel();sync();});
      on(document,'visibilitychange',sync);
      const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;sync();},{threshold:.15});
      reviewControllers.set(home,cleanup);
      reviewRemovals.observe(document.body,{childList:true,subtree:true});
      observer.observe(viewport);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  document.addEventListener('shopify:section:unload',event=>{
    reviewControllers.forEach((cleanup,home)=>{if(event.target===home||event.target.contains(home))cleanup();});
  });
})();

(()=>{
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  function init(){
    const dialog=document.querySelector('[data-renew-dialog]');
    if(dialog&&!dialog.dataset.bound){
      dialog.dataset.bound='true';let opener,index=0;
      const tabs=[...dialog.querySelectorAll('[data-renew-step]')],panels=[...dialog.querySelectorAll('[data-renew-panel]')];
      const back=dialog.querySelector('[data-renew-back]'),next=dialog.querySelector('[data-renew-next]'),plans=dialog.querySelector('[data-renew-plans]');
      function show(i){index=i;tabs.forEach((tab,n)=>{tab.setAttribute('aria-selected',String(n===i));tab.tabIndex=n===i?0:-1;tab.classList.toggle('is-complete',n<i);});panels.forEach((panel,n)=>panel.hidden=n!==i);back.disabled=i===0;next.hidden=i===tabs.length-1;plans.hidden=i!==tabs.length-1;}
      document.querySelectorAll('[data-renew-open]').forEach(button=>button.addEventListener('click',()=>{opener=button;show(0);dialog.showModal();dialog.querySelector('[data-renew-close]').focus();}));
      dialog.querySelector('[data-renew-close]').addEventListener('click',()=>dialog.close());
      dialog.addEventListener('close',()=>opener?.focus({preventScroll:true}));
      dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();});
      tabs.forEach((tab,n)=>{tab.addEventListener('click',()=>show(n));tab.addEventListener('keydown',event=>{let i=n;if(event.key==='ArrowRight')i=(n+1)%tabs.length;else if(event.key==='ArrowLeft')i=(n-1+tabs.length)%tabs.length;else if(event.key==='Home')i=0;else if(event.key==='End')i=tabs.length-1;else return;event.preventDefault();show(i);tabs[i].focus();});});
      back.addEventListener('click',()=>{show(Math.max(0,index-1));tabs[index].focus();});
      next.addEventListener('click',()=>{show(Math.min(tabs.length-1,index+1));tabs[index].focus();});
    }
    document.querySelectorAll('.eh-ai-studio').forEach(studio=>{
      if(studio.dataset.linksReady)return;studio.dataset.linksReady='true';
      const links=[...studio.querySelectorAll('[data-ai-open]')],list=studio.querySelector('[role=tablist]'),status=studio.querySelector('[data-ai-open-status]');
      const getPrompt=()=>studio.querySelector('[role=tabpanel]:not([hidden]) [data-ai-prompt]')?.value.trim()||'';
      const refresh=()=>{const prompt=getPrompt();links.forEach(link=>{const url=new URL(link.dataset.aiBase);if(link.dataset.aiOpen!=='Gemini')url.searchParams.set('q',prompt);link.href=url.href;});status.textContent=status.dataset.initial;studio.querySelector('[data-ai-fallback]').hidden=true;};
      list.addEventListener('click',refresh);list.addEventListener('keydown',refresh);refresh();
      links.forEach(link=>link.addEventListener('click',()=>{
        const prompt=getPrompt();status.textContent=link.dataset.aiOpen==='Gemini'?status.dataset.copyPending:status.dataset.opening;
        const failed=()=>{if(link.dataset.aiOpen==='Gemini'){const fallback=studio.querySelector('[data-ai-fallback]');fallback.hidden=false;fallback.querySelector('textarea').value=prompt;status.textContent=status.dataset.failed;}};
        if(navigator.clipboard?.writeText)navigator.clipboard.writeText(prompt).then(()=>{status.textContent=link.dataset.aiOpen==='Gemini'?status.dataset.paste:status.dataset.opening;},failed);else failed();
      }));
    });
    const page=document.querySelector('body.template-index');
    if(page&&!page.dataset.ambientReady){
      page.dataset.ambientReady='true';
      const glow=document.createElement('div');glow.className='eh-ambient-light';glow.setAttribute('aria-hidden','true');page.append(glow);
      let frame=0,x=0,y=0;
      page.addEventListener('pointermove',event=>{
        const root=document.documentElement,dark=root.classList.contains('dark')||root.dataset.theme==='dark';
        if(reduced.matches||event.pointerType==='touch'||!dark){glow.dataset.active='false';return;}
        x=event.clientX-320;y=event.clientY-320;glow.dataset.active='true';if(frame)return;
        frame=requestAnimationFrame(()=>{glow.style.transform=`translate3d(${x}px,${y}px,0)`;frame=0;});
      },{passive:true});
      page.addEventListener('pointerleave',()=>{glow.dataset.active='false';});
      window.addEventListener('blur',()=>{glow.dataset.active='false';});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
(function () {
  var content = document.querySelector('.sap-article__content');
  var tocNav = document.getElementById('sap-article-toc');
  var tocList = document.getElementById('sap-article-toc-list');
  if (!content || !tocNav || !tocList) return;
  var headings = content.querySelectorAll('h2, h3');
  if (headings.length < 2) return;
  headings.forEach(function (heading, index) {
    if (!heading.id) {
      heading.id = 'section-' + (index + 1);
    }
    var li = document.createElement('li');
    if (heading.tagName === 'H3') {
      li.className = 'sap-article-toc__item--nested';
    }
    var link = document.createElement('a');
    link.href = '#' + heading.id;
    link.textContent = heading.textContent;
    li.appendChild(link);
    tocList.appendChild(li);
  });
  tocNav.hidden = false;
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-blog"]) return;
  try {
    
(function () {
  var params = new URLSearchParams(window.location.search);
  var tag = params.get('tag');
  if (tag && !window.location.pathname.includes('/tagged/')) {
    var base = window.location.pathname.replace(/\/$/, '');
    window.location.replace(base + '/tagged/' + encodeURIComponent(tag));
    return;
  }

  var hub = document.querySelector('[data-sap-blog-hub]');
  if (!hub) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reducedMotion) {
    var revealEls = hub.querySelectorAll('.sap-blog-reveal');
    if (revealEls.length && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      revealEls.forEach(function (el) { io.observe(el); });
    } else {
      revealEls.forEach(function (el) { el.classList.add('is-visible'); });
    }
  } else {
    hub.querySelectorAll('.sap-blog-reveal').forEach(function (el) {
      el.classList.add('is-visible');
    });
  }

  var searchInput = hub.querySelector('[data-sap-blog-search]');
  var grid = hub.querySelector('#sap-blog-grid');
  var hint = hub.querySelector('[data-sap-blog-search-hint]');
  if (searchInput && grid) {
    var cards = grid.querySelectorAll('.sap-blog__card');
    var emptyMsg = searchInput.getAttribute('data-empty') || 'No guides on this page match your search.';
    var matchTpl = searchInput.getAttribute('data-match') || '';

    searchInput.addEventListener('input', function () {
      var q = searchInput.value.trim().toLowerCase();
      var visible = 0;
      cards.forEach(function (card) {
        var title = card.querySelector('.sap-blog__card-title');
        var text = (title ? title.textContent : '') + ' ' + (card.textContent || '');
        var show = !q || text.toLowerCase().indexOf(q) !== -1;
        card.classList.toggle('is-filtered-out', !show);
        if (show) visible += 1;
      });
      if (hint) {
        if (q && visible === 0) {
          hint.textContent = emptyMsg;
          hint.hidden = false;
        } else if (q && matchTpl) {
          hint.textContent = matchTpl.replace(['{', '{ count }', '}'].join(''), String(visible));
          hint.hidden = false;
        } else {
          hint.hidden = true;
        }
      }
    });
  }

  hub.querySelectorAll('.sap-blog-filters__btn').forEach(function (btn) {
    btn.addEventListener('focusin', function () {
      var filters = btn.closest('.sap-blog-filters');
      if (filters && filters.scrollWidth > filters.clientWidth) {
        btn.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' });
      }
    });
    btn.addEventListener('click', function () {
      btn.classList.add('is-pressed');
      window.setTimeout(function () { btn.classList.remove('is-pressed'); }, 280);
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
